export default {
  default: {
    'phone': [
      {
        id: 'san-bernardo',
        label: 'Madrid (San Bernardo)',
        display: '91 448 37 65',
        tel: '+34914483765'
      },
      {
        id: 'Madrid (goya)',
        label: 'Goya',
        display: '91 737 59 07',
        tel: '+34917375907'
      },
      {
        id: 'barcelona',
        label: 'Barcelona',
        display: '93 277 83 34',
        tel: '+34932778334'
      }
    ],
    'store': [
      {
        id: 'san-bernardo',
        label: 'Madrid (San Bernardo)',
        next: 'iFrameNexor',
        nextProps: {
          src: 'https://link.nexor.digital/widget/booking/2PiHtvxC14HJDRz3KoWa',
          id: "TsWRY2Pma7o4vBVS1OJs_1746718374963",
          width: '100%',
          border: 'none',
          overflow: 'hidden',
          scrolling: 'no',
          dataSetHeight: "850px"
        }
      },
      {
        id: 'goya',
        label: 'Madrid (Goya)',
        next: 'iFrameNexor',
        nextProps: {
          src: 'https://link.nexor.digital/widget/booking/goU6WVYjAAm1FSRoPRRF',
          id: "TsWRY2Pma7o4vBVS1OJs_1746718347046",
          width: '100%',
          border: 'none',
          overflow: 'hidden',
          scrolling: 'no',
          dataSetHeight: "850px"
        }
      },
      {
        id: 'barcelona',
        label: 'Barcelona',
        next: 'iFrameNexor',
        nextProps: {
          src: 'https://link.nexor.digital/widget/booking/5IaeQ1B8W2Jy4bfG8z4X',
          id: "TsWRY2Pma7o4vBVS1OJs_1746718396461",
          width: '100%',
          border: 'none',
          overflow: 'hidden',
          scrolling: 'no',
          dataSetHeight: "850px"
        }
      }
    ],
    'iFrameNexor': {
      title: 'FormORO',
      src: 'https://link.nexor.digital/widget/form/eXOLG359V03XEOfB11g4',
      width: '100%',
      height: '100%',
      border: 'none',
      borderRadius: '3px',
      id: 'inline-eXOLG359V03XEOfB11g4',
      layout: '{id: \'INLINE\'}',
      triggerType: 'alwaysShow',
      triggerValue: '',
      activationType: 'alwaysActivated',
      activationValue: '',
      deactivationType: 'neverDeactivate',
      deactivationValue: '',
      formName: 'FormORO',
      dataSetHeight: '450px',
      layoutIframeId: 'inline-eXOLG359V03XEOfB11g4',
      formId: 'eXOLG359V03XEOfB11g4',
    },
    'whatsapp': [
      {
        id: 'whatsapp0',
        display: '621 12 30 32',
        tel: '34621123032'
      }
    ]
  },
  madrid: {
    'phone': [
      {
        id: 'san-bernardo',
        label: 'San Bernardo',
        display: '91 448 37 65',
        tel: '+34914483765'
      },
      {
        id: 'goya',
        label: 'Goya',
        display: '91 737 59 07',
        tel: '+34917375907'
      }
    ],
    'store': [
      {
        id: 'san-bernardo',
        label: 'San Bernardo',
        next: 'iFrameNexor',
        nextProps: {
          src: 'https://link.nexor.digital/widget/booking/2PiHtvxC14HJDRz3KoWa',
          id: "TsWRY2Pma7o4vBVS1OJs_1746718374963",
          width: '100%',
          border: 'none',
          overflow: 'hidden',
          scrolling: 'no',
          dataSetHeight: "850px"
        }
      },
      {
        id: 'goya',
        label: 'Goya',
        next: 'iFrameNexor',
        nextProps: {
          src: 'https://link.nexor.digital/widget/booking/goU6WVYjAAm1FSRoPRRF',
          id: "TsWRY2Pma7o4vBVS1OJs_1746718347046",
          width: '100%',
          border: 'none',
          overflow: 'hidden',
          scrolling: 'no',
          dataSetHeight: "850px"
        }
      }
    ],
    'iFrameNexor': {
      title: 'FormORO_Madrid',
      src: 'https://link.nexor.digital/widget/form/eXOLG359V03XEOfB11g4',
      width: '100%',
      height: '100%',
      border: 'none',
      borderRadius: '3px',
      id: 'inline-eXOLG359V03XEOfB11g4',
      layout: '{id: \'INLINE\'}',
      triggerType: 'alwaysShow',
      triggerValue: '',
      activationType: 'alwaysActivated',
      activationValue: '',
      deactivationType: 'neverDeactivate',
      deactivationValue: '',
      formName: 'FormORO_Madrid',
      dataSetHeight: '450px',
      layoutIframeId: 'inline-eXOLG359V03XEOfB11g4',
      formId: 'eXOLG359V03XEOfB11g4',
    },
    'whatsapp': [
      {
        id: 'whatsapp0',
        display: '621 12 30 32',
        tel: '34621123032'
      }
    ]
  },
  barcelona: {
    'phone': [
      {
        id: 'barcelona',
        label: 'Barcelona',
        display: '93 277 83 34',
        tel: '+34932778334'
      }
    ],
    'store': [
      {
        id: 'barcelona',
        label: 'Barcelona',
        next: 'iFrameNexor',
        nextProps: {
          src: 'https://link.nexor.digital/widget/booking/5IaeQ1B8W2Jy4bfG8z4X',
          id: "TsWRY2Pma7o4vBVS1OJs_1746718396461",
          width: '100%',
          border: 'none',
          overflow: 'hidden',
          scrolling: 'no',
          dataSetHeight: "850px"
        }
      }
    ],
    'iFrameNexor': {
      title: 'FormORO_Barcelona',
      src: 'https://link.nexor.digital/widget/form/Vh3DvPlFKoADlBNam6J0',
      width: '100%',
      height: '100%',
      border: 'none',
      borderRadius: '3px',
      id: 'inline-Vh3DvPlFKoADlBNam6J0',
      layout: '{id: \'INLINE\'}',
      triggerType: 'alwaysShow',
      triggerValue: '',
      activationType: 'alwaysActivated',
      activationValue: '',
      deactivationType: 'neverDeactivate',
      deactivationValue: '',
      formName: 'FormORO_Madrid',
      dataSetHeight: '450px',
      layoutIframeId: 'inline-Vh3DvPlFKoADlBNam6J0',
      formId: 'Vh3DvPlFKoADlBNam6J0',
    },
    'whatsapp': [
      {
        id: 'whatsapp0',
        display: '621 12 30 32',
        tel: '34621123032'
      }
    ]
  }
}
